<div class="container  align-items-center">
  <div class="card-container">
    <div class="card-header" [ngStyle]="{'background-color': kleur}"></div>
    <div class="card-body">

      <h2 class="padding welcome">Welkom, {{ (user$ | async)?.email }}</h2>

      <h5 class="padding card-subtitle subTitle mb-2 text-muted">Hieronder vindt u alle mogelijke instellingen voor uw
        onderneming en
        bijhorende simulaties</h5>

      <div class="tabs border-top">

        <input type="radio" id="tab1" name="tab-control" checked>
        <input type="radio" id="tab2" name="tab-control">
        <input type="radio" id="tab3" name="tab-control">
        <input type="radio" id="tab4" name="tab-control">
        <input type="radio" id="tab6" name="tab-control">
        <ul>
          <li title="Features"><label class="navigatieKnoppen" for="tab1" role="button">
              <i class="fa fa-building" aria-hidden="true"></i>
              <br><span> Onderneming</span></label></li>
          <!-- <li title="Delivery Contents"><label class="navigatieKnoppen" for="tab2" role="button">
              <i class="fa fa-calculator" aria-hidden="true"></i>
              <br><span> VAA bedrijfswagens</span></label></li> -->
          <li title="Shipping"><label class="navigatieKnoppen" for="tab2" role="button">
              <i class="fa fa-user-plus" aria-hidden="true"></i>
              <br><span> Horeca aanwerf calculator</span></label></li>
          <li title="Returns"><label class="navigatieKnoppen" for="tab3" role="button">
              <i class="fa fa-bicycle" aria-hidden="true"></i>
              <br><span> Cash voor lease fiets</span></label></li>
          <li title="Returns"><label class="navigatieKnoppen" for="tab4" role="button">
              <i class="fa fa-plane" aria-hidden="true"></i>
              <br><span> Cash voor vakantiedagen</span></label></li>
        </ul>

        <div class="slider">
          <div class="indicator"></div>
        </div>

        <div class="content">
          <section>
            <form [formGroup]="ondernemingFormGroup" (ngSubmit)="onSubmit();">

              <h3 class="mb-5 mt-5 col-md-6 col-sm-12 underlineTitle">Onderneming</h3>


              <div class="form-row mb-3 ">

                <div class=" col-md-6   col-sm-12 ">
                  <div class="mr form-row">
                    <h5 class="tussenTitel  mb-3 "><strong>VISUEEL</strong></h5>
                  </div>
                  <div class="form-group">
                    <div class="mx-auto ">
                      <label class="font-weight-bold" for="">Primair Kleur:</label>
                      <app-color-picker (e)='setKleurKnoppen($event)' name="kleurKnoppen"
                        [heading]="'Selecteer een kleur'" [color]="kleurKnoppen"></app-color-picker>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="mx-auto">
                      <label class="font-weight-bold " for="">Secundair Kleur:</label>
                      <app-color-picker (e)='setKleur($event)' name="kleur" [heading]="'Selecteer een kleur'"
                        [color]="kleur"></app-color-picker>
                    </div>
                  </div>
                  <div class="mx-auto">
                    <label class="font-weight-bold">
                      Upload logo:
                    </label>
                    <br />
                    <input #Inputfile type="file" id="file" (change)="upload(Inputfile.files[0])" accept=".png,.jpg" />
                    <img class="" [src]="imagePath"
                      style="max-width: 200px; max-height: 200px; margin-left: 15%; margin-right: 15%; margin-top: 0.25em;" />

                    <div *ngIf=" downloadURL | async; let downloadSrc" class="alert alert-info" role="alert"></div>
                  </div>
                </div>


                <div class=" col-md-6   col-sm-12 mx-auto">
                  <div class="mr form-row">
                    <h5 class="tussenTitel  mb-3 "><strong>MODULES</strong></h5>
                  </div>
                  <div class="form-group">
                    <div class="mx-auto " formGroupName="activeModules">
                      <label class="font-weight-bold" for="">Active Modules</label>
                      <i placement="top"
                      ngbTooltip="Extra modules die u kunt activeren naast het standaard pakket."
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                      <div class="form-check form-switch">
                        <input class="form-check-input" [(ngModel)]="ondernemingForm.activeModules.opzegtermijn"
                          name="opzegtermijn" formControlName="opzegtermijn" type="checkbox" id="opzegtermijn">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Module Opzegtermijn</label>
                      </div>
                      <!-- <div class="form-check form-switch">
                        <input class="form-check-input" [(ngModel)]="ondernemingForm.activeModules.test" name="test"
                          formControlName="test" type="checkbox" id="test">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Test Module</label>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-group">

                    <label class="font-weight-bold " for="textArea">Algemene Waarschuwing:</label>
                    <i placement="top"
                      ngbTooltip="Een algemene waarschuwing die onder elke simulatie verschijnt."
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                    <textarea [(ngModel)]="ondernemingForm.algemeneWaarschuwing" formControlName="algemeneWaarschuwing"
                      name="algemeneWaarschuwing" id="algemeneWaarschuwing" class="form-control" rows="3"></textarea>
                  </div>
                  
                </div>
              </div>




              <!-- <div class="form-group col-md-6 col-sm-12">
                   <div *ngIf="cash4BikeFormGroup.controls.tekstWaarschuwing.errors" class="text-danger md-1">
                        {{err[0]}}
                    </div> 
                    <label class="font-weight-bold " for="textArea">Waarschuwingsbericht:</label>
                    <textarea
                      name="algemeneWaarschuwing" id="algemeneWaarschuwing" formControlName="algemeneWaarschuwing" class="form-control" rows="3"></textarea>
                  </div> -->




              <div class="mr form-row h-100">
                <h5 class="tussenTitel  mb-3 mt-3"><strong>EXTERNE LINK</strong>
                  <i placement="top"
                    ngbTooltip="Verwijs gebruikers door naar een externe website via een link. Indien ingevuld, zal deze link verschijnen op de hoofdpagina tussen de andere simulaties. Indien u geen externe link wenst, hou dan deze velden leeg."
                    class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                </h5>
              </div>
              <div class="form-row">


                <div class="col-md-6  col-sm-12 ">

                  <div class="form-group">
                    <div *ngIf="ondernemingFormGroup.controls.omschrijving.errors" class="text-danger md-1">
                      Title kan niet langer zijn dan 30 karakters.
                    </div>
                    <label class="font-weight-bold " for="omschrijving">Titel:</label>
                    <input type="text" [(ngModel)]="ondernemingForm.omschrijving" name="omschrijving"
                      formControlName="omschrijving" class="form-control" rows="1" />
                  </div>


                  <div class="form-group">
                    <div *ngIf="ondernemingFormGroup.controls.link.errors" class="text-danger md-1">
                      De opgegeven link voldoet niet aan de correcte syntax
                      (vb: https://www.google.be/)
                    </div>
                    <label class="font-weight-bold " for="link">Externe link:</label>
                    <input type="text" [(ngModel)]="ondernemingForm.link" name="link" formControlName="link"
                      class="form-control" />
                  </div>

                </div>

              </div>
              <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': kleur}"></div>
              <div class="form-row">
                <div class="col-md-6   col-sm-12 "></div>
                <div class="col-md-6   col-sm-12 ">
                  <button [disabled]="!ondernemingFormGroup.valid" class="btn btn-dark btn-lg float-right mt-2"
                    type="submit">OPSLAAN</button>
                </div>

              </div>
            </form>
          </section>
          <!-- <section>
            <app-admin-vaa [ondernemingNaam]="ondernemingNaam"></app-admin-vaa>
          </section> -->
          <section>
            <app-admin-aanwerfsimulator [ondernemingNaam]="ondernemingNaam"> </app-admin-aanwerfsimulator>
          </section>
          <section>
            <app-admin-cash4bike [ondernemingNaam]="ondernemingNaam"></app-admin-cash4bike>
          </section>
          <section>
            <app-admin-holiday-value [ondernemingNaam]="ondernemingNaam"></app-admin-holiday-value>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>